<script setup lang="ts">
import { TooltipArrow, TooltipContent, TooltipPortal, TooltipProvider, TooltipRoot, TooltipTrigger } from 'reka-ui'

defineProps<{
  label: string
  // A trigger slot that holds its own button takes the trigger props itself, since a button inside a button breaks SSR hydration.
  asChild?: boolean
}>()
</script>

<template>
  <TooltipProvider>
    <TooltipRoot :delay-duration="200">
      <TooltipTrigger :as-child="asChild">
        <slot name="trigger" />
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContent
          class="shadow-sm select-none rounded-md bg-neutral-white dark:bg-surface-elevated px-s py-2xs text-caption data-[state=delayed-open]:data-[side=top]:animate-fade z-50"
          :side-offset="5"
        >
          {{ label }}
          <TooltipArrow class="fill-white dark:fill-surface-elevated" :width="12" :height="6" />
        </TooltipContent>
      </TooltipPortal>
    </TooltipRoot>
  </TooltipProvider>
</template>
